import { render } from "./doctorInfo.vue?vue&type=template&id=5b8b3bae"
import script from "./doctorInfo.vue?vue&type=script&lang=js"
export * from "./doctorInfo.vue?vue&type=script&lang=js"

import "./doctorInfo.vue?vue&type=style&index=0&id=5b8b3bae&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__